module.exports = "e8f121a4625dca071da17ce380ffe8c2.wav";


//////////////////
// WEBPACK FOOTER
// ./assets/sfx/hurt.wav
// module id = 91
// module chunks = 0